import { defineMessages } from 'react-intl';

export const artifactPanelMessages = defineMessages({
  tasksTitle: {
    defaultMessage: 'Tasks',
    id: 'ZvqZDDcuZM',
    description: 'Title for the clinical tasks artifact panel',
  },
  clinicalCodesTitle: {
    defaultMessage: 'Clinical codes',
    id: 'IB8XxV/APP',
    description: 'Title for the clinical codes artifact panel',
  },
  letterTitle: {
    defaultMessage: 'Letter',
    id: 'Bv58HZfE8A',
    description: 'Title for a letter artifact panel',
  },
  focusedArtifactClose: {
    defaultMessage: 'Close {title}',
    id: 'eyF3PosZ/Q',
    description: 'Accessible label of the close button on a focused artifact chip',
  },
  focusedArtifactExport: {
    defaultMessage: 'Export',
    id: 'wxxHO7sl6s',
    description: 'Button downloading a letter artifact as a PDF',
  },
  letterSendLetter: {
    defaultMessage: 'Send letter',
    id: 'ayeSKXhz3U',
    description: 'Button opening the letter sender in its source session',
  },
  focusedArtifactOpenInSession: {
    defaultMessage: 'Open in session',
    id: 'pVDgx4Stax',
    description: 'Button opening a letter artifact in its source session',
  },
  letterLoading: {
    defaultMessage: 'Loading letter…',
    id: 'Sk4ET7hjgu',
    description: 'Loading state for a letter artifact preview',
  },
  letterSessionNavigationFailed: {
    defaultMessage: 'Couldn’t open this letter in its session. Please try again.',
    id: 'V34GPqy64r',
    description: 'Error shown when opening a letter artifact in its session fails',
  },
  sessionNavigationFailed: {
    defaultMessage: 'Couldn’t open this session. Please try again.',
    id: 'UhsvY23//R',
    description: 'Error shown when navigating from Work to a session page fails',
  },
  letterUnavailable: {
    defaultMessage: "This letter isn't available.",
    id: 'VN/FxF3EZS',
    description: 'Non-disclosing unavailable state for a letter artifact',
  },
  letterUnavailableClose: {
    defaultMessage: 'Close',
    id: '8d0HGi56nH',
    description: 'Button closing an unavailable letter artifact',
  },
  openPatient: {
    defaultMessage: 'Open patient',
    id: 'G729tii4yY',
    description: 'Button opening a patient profile from its artifact preview',
  },
  loadingForm: {
    defaultMessage: 'Loading form',
    id: 'uWXeyA+fSV',
    description: 'Loading state while a form template artifact loads',
  },
  closePanel: {
    defaultMessage: 'Close panel',
    id: 'J1Oah6Q0me',
    description: 'Aria label for closing an artifact panel',
  },
  libraryTitle: {
    defaultMessage: 'Artifacts',
    id: 'IKEB+JQ13w',
    description: 'Title of the Artifacts panel on the Work home canvas',
  },
  libraryDocumentCount: {
    defaultMessage: '{count, plural, one {# document} other {# documents}}',
    id: '9u5wB0Kg3j',
    description: 'Count of library documents, shown under the Artifacts panel title',
  },
  libraryGoToLibrary: {
    defaultMessage: 'Go to library',
    id: 'wuSzj85Ls1',
    description: 'Hero action on the Artifacts panel that opens the Library',
  },
  workflowBackToOverview: {
    defaultMessage: 'Back to overview',
    id: 'LtZxBzjVu/',
    description: 'Returns the routine artifact from configuration edit to the overview',
  },
  workflowFallbackTitle: {
    defaultMessage: 'Routine',
    id: 'ylBlebSrOD',
    description: 'Fallback title for a routine artifact before its name loads',
  },
  createdObjectUnavailable: {
    defaultMessage: 'This object isn’t available.',
    id: 'prpWMzM1w1',
    description: 'Shown when a created-object chip has no resolvable artifact',
  },
});
